export default __webpack_public_path__ + "static/media/EM1980.34I-43320_-26096_0.5e7b9d17.jpg";